module.exports = __webpack_public_path__ + "img/la-tomatina-2012-3.be3af596.jpg";